import React from 'react';
import {Container, Typography, Box, Divider} from '@mui/material';

function Footer() {
    return (
        <Container sx={{ padding: '64px 0 32px',  overflow: 'hidden'}}>
            <Divider />
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', paddingTop: '16px', gap: '8px' }}>
                <Typography variant="p" component={'p'} fontStyle={'italic'}>
                    ©Gabriele Castoro
                </Typography>
                <Typography variant="p" component={'p'} fontStyle={'italic'}>
                    Custom portfolio built with React JS.
                </Typography>
                <Typography variant="p" component={'p'} fontStyle={'italic'} fontSize={'small'}>
                    Last update: <strong>05/2025</strong>
                </Typography>
            </Box>
        </Container>
    );
}

export default Footer;